// ---------- average APR presets ----------
const AVERAGE_RATES = {
  "Credit Card": { goodCredit: "~ 20% - 25%", higherRisk: "~ 30% - 40%" },
  "Store Card": { goodCredit: "~ 25% - 30%", higherRisk: "~ 35% - 45%" },
  Overdraft: { goodCredit: "~ 20% - 30%", higherRisk: "~ 30% - 40%" },
  "Unsecured Loan": { goodCredit: "~ 5% - 10%", higherRisk: "~ 15% - 30%" },
  "Secured Loan": { goodCredit: "~ 4% - 8%", higherRisk: "~ 10% - 20%" },
  "Car Finance": { goodCredit: "~ 6% - 12%", higherRisk: "~ 12% - 25%" },
};

// Parse strings like "~ 20% - 25%" → 22.5
const midOfRangePct = (s) => {
  if (!s) return 0;
  const nums = String(s)
    .replace(/[^0-9.\-–—% ]/g, "")
    .split(/[-–—]/)
    .map((t) => parseFloat(t.replace("%", "").trim()))
    .filter((n) => Number.isFinite(n));
  if (nums.length === 2) return (nums[0] + nums[1]) / 2;
  if (nums.length === 1) return nums[0];
  return 0;
};

// Default to goodCredit midpoint. You can flip to "higherRisk" if needed.
const defaultAprForLabel = (label, band = "goodCredit") => {
  const key = (label || "").trim();
  const row = AVERAGE_RATES[key];
  if (!row) return 0;
  return midOfRangePct(row[band]) || 0;
};

export { defaultAprForLabel, AVERAGE_RATES };
